import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-air-blow',
  templateUrl: './air-blow.component.html',
  styleUrls: ['./air-blow.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AirBlowIconComponent {}
